import React, { useContext, useRef, useState } from 'react'
import { ButtonHeading, FuelStationDetailsTab } from 'components';
import { constant } from 'constants/constant';
import Tab from 'components/common/Tab';
import LoadingBar from 'react-top-loading-bar';
import Ledger from '../Ledger';
import FuelStatement from '../FuelStatement';
import { useLocation, useNavigate } from 'react-router-dom';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { AdjustBalanceModal } from 'modals';
import { UserContext } from 'context';

const FuelStationDetails = () => {
    useDocumentTitle("Fuel Station Details | T360");

    const location = useLocation();
    const navigate = useNavigate();
    const { setMasterDetailsList } = useContext(UserContext);
    const queryParams = new URLSearchParams(location.search);
    const stationName = queryParams.get('name') || '';
    const tabFromQuery = parseInt(queryParams.get('tab')) || 1;
    const [activeTab, setActiveTab] = useState(tabFromQuery);
    const [fuelData, setFuelData] = useState(null)
    const loadingBarRef = useRef(null)
    const [openLedgerModal, setOpenLedgerModal] = useState(false);
    const [refreshLedger, setRefreshLedger] = useState(false);
    const [ledgerDetails, setLedgerDetails] = useState({});

    const handleActiveTabs = (e) => {
        setActiveTab(e);

        const params = new URLSearchParams(location.search);
        params.set('tab', e);
        navigate(`${location.pathname}?${params.toString()}`);
    }

    const tabProps = {
        tabList: constant.fuel_StationDetailsTabs,
        callBackTab: (e) => handleActiveTabs(e),
        activeTab: activeTab
    }

    const onDataFetch = (data) => {
        setFuelData(data)
    }

    const calback = () => {
        setOpenLedgerModal(false)
        setRefreshLedger(prev => !prev);
    }

    let LedgerAdjustModalProps = {
        isOpen: openLedgerModal,
        closeModal: (e) => setOpenLedgerModal(false),
        modalMainClass: "_dashCommon_Modal _prtThemeModal _smModal",
        footerPart: false,
        approvalBtn: true,
        approvalBtnTxt: 'Send for Approval',
        modalTitle: "Adjust Balance",
        submitTitle: "Adjust Balance",
        detailsData: ledgerDetails,
        venderType: "Fuel Station",
        calback: calback
    }
    return (
        <div className=''>
            <LoadingBar
                color="#ffa800"
                ref={loadingBarRef}
                height={4}
                shadow={true}
                loaderSpeed={1000}
            />
            <ButtonHeading
                title={stationName ? stationName : (fuelData?.name ? fuelData?.name : 'Fuel Station')}
                buttonTitle="Back"
                isBackButton={true}
                onClickBackButton={() => { navigate('/account/fuel_station'); setMasterDetailsList({}) }} // navigate(-1)
                ledgerButtonTitle={activeTab == 2 ? "Adjust Balance" : ""}
                ledgerOnClick={() => setOpenLedgerModal(true)}
            />

            <div className='addPr_flBx'>
                <Tab {...tabProps} />
                {activeTab === 1 && (
                    <FuelStationDetailsTab onDataFetch={onDataFetch} loadingBarRef={loadingBarRef} />
                )}
                {activeTab === 2 && <Ledger type={5} refresh={refreshLedger} setLedgerDetails={setLedgerDetails} />}
                {activeTab === 3 && <FuelStatement />}
                {openLedgerModal && <AdjustBalanceModal {...LedgerAdjustModalProps} />}
            </div>

        </div>
    )
}

export default FuelStationDetails;